import styled from 'styled-components';
import Icon from '../../Icon';
import { Link } from 'react-router-dom';

export const StyledHeaderContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  color: ${({ theme }): string => theme.colors.normalText};
  font-size: ${({ theme }): string => theme.fontSizes[10]};
  font-weight: ${({ theme }): string => theme.fontWeights[6]};
  box-shadow: ${({ theme }): string => theme.shadows.header};
`;

export const StyledLink = styled(Link)<{ goBack: boolean }>`
  position: absolute;
  left: 18px;
`;
